export const BASE_URL = "https://api.crmsft.com/v1/admin/";
// export const BASE_URL = "http://localhost:8081/v1/admin/";
export const BASE_URL_SUPERADMIN =
  "https://api.crmsft.com/v1/super-admin/admins/";
// "http://localhost:8081/v1/super-admin/admins/";

// export const BASE_URL = "http://crm-new.matrixinfotechsolution.in/v1/admin/";
// export const BASE_URL_SUPERADMIN =
  // "http://crm-new.matrixinfotechsolution.in/v1/super-admin/";

export const CLOUDINARY_CLOUD_NAME = "dkhh3ayz8";
export const CLOUDINARY_API_KEY = 623975788157223;
export const CLOUDINARY_API_SECRET = "YQMosUit4Gwj5v_egGXv1aNINGE";

export const PAYPAL_CLIENT_ID =
  "AZdkVuAleE_1oSzYmJEu83Z5QpJg2cFHHtiVsXYZbI1rqoLlF_qS1WPz3lx3S386cA_75iwfnnSmyUF5";
